import React from 'react';
import { Button } from './Button';
import { LockIcon, ZapIcon, ShieldCheckIcon, SmartphoneIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-14 md:py-24 bg-brand-dark text-white border-t border-slate-800" data-id="element-123">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-124">
        <h2 className="text-3xl md:text-5xl font-black mb-6 md:mb-8 text-white" data-id="element-125">
          Asegurá tu acceso ahora
        </h2>

        <p className="text-base md:text-xl text-slate-300 mb-10 md:mb-12 max-w-2xl mx-auto" data-id="element-126">
          El precio de{' '}
          <span className="text-brand-accent font-bold" data-id="element-127">$19.990 ARS</span> es de
          lanzamiento. Una vez que se acaben los cupos, sube a $34.990 ARS.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-128">
          <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 flex flex-col items-center" data-id="element-129">
            <h3 className="font-bold text-lg mb-2" data-id="element-130">MEGAPACK COLUMNA</h3>
            <div className="text-3xl font-black text-white mb-6" data-id="element-131">
              Precio hoy: $19.990 ARS
            </div>
            <Button variant="outline" fullWidth onClick={() => document.getElementById('pricing')?.scrollIntoView()} data-id="element-132">
              QUIERO EMPEZAR HOY
            </Button>
          </div>

          <div className="bg-brand-accent/10 border border-brand-accent rounded-xl p-6 flex flex-col items-center relative overflow-hidden" data-id="element-133">
            <div className="absolute top-0 w-full h-1 bg-brand-accent left-0" data-id="element-134"></div>
            <h3 className="font-bold text-lg mb-2 text-brand-accent" data-id="element-135">
              PACK COMPLETO + PRO ÉLITE
            </h3>
            <div className="text-3xl font-black text-white mb-6" data-id="element-136">
              Precio hoy: $27.990 ARS
            </div>
            <Button variant="primary" fullWidth onClick={() => document.getElementById('pricing')?.scrollIntoView()} data-id="element-137">
              QUIERO EL PACK COMPLETO
            </Button>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-6 md:gap-10 text-sm font-medium text-slate-400" data-id="element-138">
          <div className="flex items-center gap-2" data-id="element-139">
            <LockIcon className="w-5 h-5 text-emerald-500" data-id="element-140" /> Pago seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-141">
            <ZapIcon className="w-5 h-5 text-emerald-500" data-id="element-142" /> Acceso inmediato
          </div>
          <div className="flex items-center gap-2" data-id="element-143">
            <ShieldCheckIcon className="w-5 h-5 text-emerald-500" data-id="element-144" /> Garantía 30
            días
          </div>
          <div className="flex items-center gap-2" data-id="element-145">
            <SmartphoneIcon className="w-5 h-5 text-emerald-500" data-id="element-146" /> Funciona
            desde el celular
          </div>
        </div>
      </div>
    </section>;
}